import color from '@/uptk/core/packages/style/color';
import typography from '@/uptk/core/packages/style/typography';

const base = {
  body: {
    ...typography.sansSerifBody1
  },
  a: {
    color: color.grey700,
    textDecoration: 'underline',
    '&:hover': {
      color: color.blue800
    },
    '&:active': {
      color: color.teal700
    },
    '.uitk-dark &': {
      color: color.grey200,
      textDecoration: 'underline',
      '&:hover': {
        color: color.blue500
      },
      '&:active': {
        color: color.teal500
      }
    }
  },
  accessibleText: {
    display: 'block',
    potition: 'absolute',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    top: 0,
    left: 0,
    opacity: 0.01
  },
  iconFont: {
    // fontFamily: '"uitk-icons", !important',
 	fontFamily: 'agGridBalham !important',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontVariant: 'normal',
    textTransform: 'none',
    speak: 'none'
  },
  ':focus': {
    outline: 'none'
  }
};

export default base;
